import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import Quote from '../../Quote/Quote.jsx';

export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8 push-l4">
                    <Markdown>
                        {contentToText(content['shipping-health-solutions2'],{
                            battlequote: <Quote quote="We're gearing up for the battle" credit="Bill Hemmings, Director of Aviation and Shipping at NGO Transport and Environment" position="left"/>
                        })}
                    </Markdown>
                </div>
            </div>
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/HealthSolutions2/HealthSolutions2.jsx